var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadsetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4777_73349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 48C141.1 48 48 141.1 48 256V296C48 309.3 37.3 320 24 320C10.7 320 0 309.3 0 296V256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256V400.1C512 448.7 472.6 488.1 423.9 488.1L313.6 488C305.3 502.3 289.8 512 272 512H240C213.5 512 192 490.5 192 464C192 437.5 213.5 416 240 416H272C289.8 416 305.3 425.7 313.6 440L424 440.1C446.1 440.1 464 422.2 464 400.1V256C464 141.1 370.9 48 256 48ZM144 208H160C177.7 208 192 222.3 192 240V352C192 369.7 177.7 384 160 384H144C108.7 384 80 355.3 80 320V272C80 236.7 108.7 208 144 208ZM368 208C403.3 208 432 236.7 432 272V320C432 355.3 403.3 384 368 384H352C334.3 384 320 369.7 320 352V240C320 222.3 334.3 208 352 208H368Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4777_73349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetIcon);
export default __webpack_public_path__ + "static/media/headset-icon.641ff39ca62672f5816c1714f1ee9c73.svg";
export { ForwardRef as ReactComponent };